var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('navbar'),_c('profile'),_c('monitriip-notice'),_c('scam-alert-notice'),_c('div',{staticClass:"row"},[_c('side-bar'),_c('settings-side-bar'),_c('app-main',{staticClass:"divMain"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }